import React, { useEffect, useState, useCallback } from "react";
import ReusableMuiTable from "../../../components/common/Table/Table";
import Box from "@mui/material/Box";
import { IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getProductCategorylist, deleteCategoryById } from "../../../api/service/products.service";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";

const Category = () => {
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchProductlist = useCallback(async () => {
    try {
      setLoading(true);

      const res = await getProductCategorylist({
        search,
        page,
        limit: 10,
      });

      const products = res?.data || [];

      setProductlist(products);
      setTotalPages(res?.lastPage || 1);
    } catch (error) {
      console.error("Failed to fetch products:", error);
    } finally {
      setLoading(false);
    }
  }, [page, search]);


  useEffect(() => {
    fetchProductlist();
  }, [fetchProductlist]);

  // console.log(productlist, "productlist......");

  const addCategory = () => navigate("/add-product-category");


  const addCategorySpecification = (id) => navigate(`/category-specification/${id}`);


  const handleEdit = (rowData) => navigate(`/update-product-category/${rowData.id}`);

  const handleDelete = useCallback((rowData) => {
    const id = rowData.id || rowData._id;
    // console.log(id, "Rowid...")
    Swal.fire({
      title: "Are you sure to delete this category ?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#C39B22",
      cancelButtonColor: "#d32f2f",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {

        try {
          setLoading(true);
          await deleteCategoryById(id);

          Swal.fire({
            title: "Deleted!",
            text: "Category has been deleted successfully.",
            icon: "success",
            confirmButtonColor: "#C39B22",
          });

          fetchProductlist();
          showToast.success("Category deleted successfully");

        } catch (error) {
          console.error("Delete error:", error);
          showToast.error(error?.message || "Failed to delete the product. Please try again.");

          Swal.fire({
            title: "Error!",
            text: "Something went wrong while deleting.",
            icon: "error",
            confirmButtonColor: "#C39B22",
          });
        } finally {
          setLoading(false);
        }
      }
    });
  }, [fetchProductlist]);

  const columns = [
    {
      name: "title",
      label: "Category Title",
    },
    {
      name: "sub_title",
      label: "Category Subtitle",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowData = productlist[tableMeta.rowIndex];
          if (!rowData) return null;

          return (
            <Box sx={{
              maxWidth: "120px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}>


              {rowData.sub_title}

            </Box>
          );
        },
      },
    },
    {
      name: "text",
      label: "Category Specification",
      options: {
        customBodyRender: (value, tableMeta) => {

          const rowData = productlist[tableMeta.rowIndex];
          const row = productlist[tableMeta.rowIndex];
          if (!row) return "-";


          const count = row.specifications_count ?? 0;

          const displayNumber = tableMeta.rowIndex + 1;

          return (
            <Box
              onClick={() => addCategorySpecification(rowData.id)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "#C39B22",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "14px",
                cursor: "pointer",
                "&:hover": { opacity: 0.8 },
              }}
            >
              {count}
            </Box>
          );
        },
      },
    },
    {
      name: "text",
      label: "Category Product",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowData = productlist[tableMeta.rowIndex];
          const row = productlist[tableMeta.rowIndex];
          if (!row) return "-";


          const count = row.products_count ?? 0;




          return (
            <Box
              onClick={() =>
                navigate(`/category/${rowData.id}`)
              }
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "#C39B22",
                color: "#fff",
                fontWeight: "bold",
                fontSize: "14px",
                cursor: "pointer",
                "&:hover": { opacity: 0.8 },
              }}
            >
              {count}
            </Box>
          );
        },
      },
    },




    {
      name: "action",
      label: "Action",
      options: {
        customBodyRender: (_, tableMeta) => {
          const rowData = productlist[tableMeta.rowIndex];
          if (!rowData) return null;

          return (
            <Box sx={{ display: "flex", gap: 1 }}>
              <Tooltip title="Edit">
                <IconButton
                  size="small"
                  onClick={() => handleEdit(rowData)}
                  sx={{ color: "#C39B22" }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  onClick={() => handleDelete(rowData)}
                  sx={{ color: "#d32f2f" }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              {/* <Tooltip title="Add Details">
                <IconButton
                  size="small"
               
                  sx={{ color: "#C39B22" }}
                >
                  <BiCartAdd size={18} />
                </IconButton>
              </Tooltip> */}
            </Box>
          );
        },
      },
    },
  ];

  return (
  
    <>
      <ReusableMuiTable
        title="Category List"
        data={productlist}
        columns={columns}
        options={{
          search: true,
          serverSide: true,
          page: page - 1,
          count: totalPages * 10,
          rowsPerPage: 10,

          onChangePage: (newPage) => {
            setPage(newPage + 1);
          },

          onSearchChange: (searchText) => {
            setSearch(searchText || "");
            setPage(1);
          },

          onSearchClose: () => {
            setSearch("");
            setPage(1);
          },
        }}
        customToolbarRight={
          <Button
            variant="contained"
            onClick={addCategory}
            sx={{
              backgroundColor: "#C39B22",
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Add Categorylist
          </Button>
        }
      />

    </>
  );
};

export default Category;